import { notification } from 'antd';
import React, { useState } from 'react';

import { BasketMiniature } from '@/components/elements/favorite-basket-miniature/basket-miniature';
import { ReservationModal } from '@/components/modules/product-page/ui/reservation-modal';
import { ReservationNotification } from '@/components/modules/product-page/ui/reservation-notification';
import { useAppDispatch } from '@/store/hooks';
import { addProductBasket } from '@/store/reducers/basket/slice';
import { closeModal, showModal } from '@/store/reducers/modal/slice';

import { TFullRentProduct } from '@/entities/product';

import { STORAGE_KEYS } from '@/shared/constants/storage-keys';
import { useTranslate } from '@/shared/hooks/use-translate';
import { LocalStore } from '@/shared/utils/local-store';

type TUseReservationProductReturn = {
    contextHolder: React.ReactElement<unknown, string | React.JSXElementConstructor<unknown>>;
    isDisabledReservation: boolean;
    showReservationModal: () => void;
};

export const useReservationProduct = ({ product }: { product: TFullRentProduct }): TUseReservationProductReturn => {
    const dispatch = useAppDispatch();

    const { t } = useTranslate();

    const [msg, contextHolder] = notification.useNotification();

    const [isDisabledReservation, setIsDisabledReservation] = useState(false);

    const successNotification = () => {
        // TODO [ ARKZ-323 ] реализовать модуль Notification
        msg.open({
            message: <ReservationNotification product={product} title={t('Ожидайте подтверждения бронирования')} />,
            style: { width: 'fit-content' },
            placement: 'topRight',
            duration: 0,
            onClose: () => {
                setIsDisabledReservation(false);
            },
        });

        setIsDisabledReservation(true);
    };

    //already-in-basket-notification
    const alreadyInBasketNotification = () => {
        msg.open({
            message: <ReservationNotification product={product} title={t('Уже в корзине')} />,
            style: { width: 'fit-content' },
            placement: 'topRight',
            duration: 5,
        });
    };

    const addLandingProductToBasket = () => {
        const basketProductsItems: number[] = LocalStore.get(STORAGE_KEYS.basketProducts);

        if (basketProductsItems && !basketProductsItems.includes(product.id)) {
            dispatch(addProductBasket({ product }));

            LocalStore.set(STORAGE_KEYS.basketProducts, [product.id, ...basketProductsItems]);

            dispatch(
                showModal({
                    type: 'Notification',
                    content: <BasketMiniature />,
                }),
            );
        } else {
            alreadyInBasketNotification();
        }

        dispatch(closeModal());
    };

    const showReservationModal = () => {
        dispatch(
            showModal({
                size: 'Medium',
                title: 'Забронировать в один клик',
                content: (
                    <ReservationModal
                        productId={product.id}
                        successNotification={successNotification}
                        addLandingProductToBasket={addLandingProductToBasket}
                    />
                ),
            }),
        );
    };

    return { showReservationModal, contextHolder, isDisabledReservation };
};
